<script lang="ts">
  export let element = "a";
  export let href = "";
</script>

<svelte:element this={element} href={href ? href : null} class="btn"
  ><slot /></svelte:element
>
